/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Module containing components, pipes and services used in Avi Header.
 * @module HeaderModule
 * @preferred
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import { ClrSpinnerModule } from '@clr/angular';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from 'ng/shared/shared.module';
import { AviFormsModule } from 'ng/modules/avi-forms/avi-forms.module';
import { CoreModule } from 'ng/modules/core/core.module';
import { SystemModule } from 'ng/modules/system/system.module';
import { HttpModule } from 'ng/modules/http/http.module';
import { DialogModule } from 'ng/modules/dialog/dialog.module';

import {
    AppAboutModalComponent,
    AviMainHeaderComponent,
    AviMainHeaderControllerSiteSelectorComponent,
    AviMainHeaderTenantSelectorComponent,
    AviMainHeaderUserCardComponent,
    AviMainHeaderUserMenuComponent,
    AviMainHeaderUserMenuContainerComponent,
    BrandingComponent,
    GenerateSsoTokenDialogComponent,
    StateGroupPipe,
    StateNamePipe,
} from '.';

import {
    activeUserProfileServiceProvider,
    userItemProvider,
} from './ajs-upgraded-providers';

const headerComponents = [
    AppAboutModalComponent,
    AviMainHeaderComponent,
    AviMainHeaderControllerSiteSelectorComponent,
    AviMainHeaderTenantSelectorComponent,
    AviMainHeaderUserCardComponent,
    AviMainHeaderUserMenuComponent,
    AviMainHeaderUserMenuContainerComponent,
    BrandingComponent,
    GenerateSsoTokenDialogComponent,
];

const headerPipes = [
    StateGroupPipe,
    StateNamePipe,
];

@NgModule({
    declarations: [
        ...headerComponents,
        ...headerPipes,
    ],
    exports: [
        AppAboutModalComponent,
        AviMainHeaderComponent,
        BrandingComponent,
    ],
    imports: [
        A11yModule,
        AviFormsModule,
        ClrSpinnerModule,
        CommonModule,
        CoreModule,
        DialogModule,
        HttpModule,
        SharedModule,
        SystemModule,
        UIRouterModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    providers: [
        activeUserProfileServiceProvider,
        userItemProvider,
    ],
})
export class HeaderModule {}
